import { useRef, useState } from "react";

import { Col, Row } from "antd";
import {
  EditOutlined,
  UploadOutlined,
} from "@ant-design/icons";
import { MEDIA_URL, MEMBER_MEDIA_URL } from "../../utility/URL";

const styles = {
  withcursor: {
    position: "absolute",
    top: 0,
    left: 0,
    opacity: 0,
    width: "100%",
    height: "100%",
    cursor: "pointer",
  },
  withoutcursor: {
    position: "absolute",
    top: 0,
    left: 0,
    opacity: 0,
    width: "100%",
    height: "100%",
    cursor: "none",
    pointerEvents: "none",
  },
  changePhoto: {
    textAlign: "center",
    fontWeight: "500",
    marginTop: "4px",
    color: "rgb(255, 255, 255)",
    cursor: "pointer",
    background: "#1a8811",
    borderRadius: "4px",
    fontSize: "11px",
    padding: "3px 0",
  },
  removePhoto: {
    textAlign: "center",
    fontWeight: "500",
    marginTop: "4px",
    color: "rgb(255, 255, 255)",
    cursor: "pointer",
    background: "rgb(255, 31, 62)",
    borderRadius: "4px",
    fontSize: "15px",
    padding: "0px 0",
  },
  profilePicView: {
    width: "100%",
    height: "100%",
    objectFit: "cover",
    borderRadius: "10px",
  },
};

const CustomFileUploadProfile = (props) => {
  return (
    <>
      <Row>
        <Col>
          <div style={{ position: "relative" }}>
            <input
              type="file"
              ref={props.inputFileRef}
              onChange={props.handleFileChange}
              style={
                props.file || props.profilePic != ""
                  ? styles.withoutcursor
                  : styles.withcursor
              }
            />

            <button
              type="button"
              style={{
                width: "150px",
                height: "150px",
                borderRadius: "10px",
                backgroundColor: "#f4f4f4",
                color: "#fff",
                border: "0px dashed #d7d7d7",
              }}
            >
              {props.file || props.profilePic != "" ? (
                <div
                  style={{
                    width: "150px",
                    height: "150px",
                    borderRadius: "10px",
                  }}
                >
                  {props.file ? (
                    <>
                      <img
                        src={URL.createObjectURL(props.file)}
                        alt="Preview"
                        style={styles.profilePicView}
                      />
                    </>
                  ) : (
                    <>
                      <img
                        src={props.laravelImagePath ? `${MEMBER_MEDIA_URL}${props.profilePic}` : `${MEDIA_URL}/${props.profilePic}`}
                        alt="Preview"
                        style={styles.profilePicView}
                      />
                    </>
                  )}
                </div>
              ) : (
                <>
                  <UploadOutlined
                    style={{ fontSize: "26px", color: "#323232" }}
                  />
                  <p style={{ color: "#323232" }}>Upload</p>
                </>
              )}
            </button>
          </div>
          {props.file || props.profilePic != "" ? (
            <>
              <Row gutter={6}>
                <Col xs={24} sm={24}>
                  <p style={styles.changePhoto} onClick={props.onBtnClick}>
                    <EditOutlined /> Change Photo
                  </p>
                </Col>
              </Row>
            </>
          ) : (
            <></>
          )}
        </Col>
        <Col></Col>
      </Row>
    </>
  );
};

export default CustomFileUploadProfile;
